var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ManualOrders',{attrs:{"location":"it"}})
}
var staticRenderFns = []

export { render, staticRenderFns }